import type { INotificationRepository } from "@/application/ports/repositories";
import type {
  Notification,
  NotificationStats,
  NotificationListResponse,
  GetNotificationsParams,
} from "@/domain";
import * as sdk from "../generated/sdk.gen";
import { unwrap } from "../unwrap";

export class NotificationRepository implements INotificationRepository {
  async getNotifications(
    params?: GetNotificationsParams,
    signal?: AbortSignal,
  ): Promise<NotificationListResponse> {
    const { items, ...rest } = await unwrap(sdk.getNotifications({ query: params, signal }));
    return { notifications: items, ...rest };
  }
  async getNotificationStats(signal?: AbortSignal): Promise<NotificationStats> {
    return unwrap(sdk.getNotificationStats({ signal }));
  }
  async getNotification(uuid: string): Promise<Notification> {
    return unwrap(sdk.getNotification({ path: { notification_uuid: uuid } }));
  }
  async markAsRead(uuid: string): Promise<void> {
    await unwrap(sdk.markAsRead({ path: { notification_uuid: uuid } }));
  }
  async markAsUnread(uuid: string): Promise<void> {
    await unwrap(sdk.markAsUnread({ path: { notification_uuid: uuid } }));
  }
  async markAllAsRead(): Promise<void> {
    await unwrap(sdk.markAllAsRead());
  }
  async deleteNotification(uuid: string): Promise<void> {
    await unwrap(sdk.deleteNotification({ path: { notification_uuid: uuid } }));
  }
  async deleteAllNotifications(): Promise<void> {
    await unwrap(sdk.deleteAllNotifications());
  }
}
